import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class ChequePrintTemplate extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			status: props.Status,
			data: null,
			loading: true,
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.httpPost("api/v1/chequeprinttemplate/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.setState({
						data: data,
						loading: false
					});
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save() {
		this.httpPost("api/v1/chequeprinttemplate/save", {
			id: this.state.id,

			title: this.state.data.record.title,
			width: this.state.data.record.width,
			height: this.state.data.record.height,

			printAmount: this.state.data.record.printAmount,
			amountX: this.state.data.record.amountX,
			amountY: this.state.data.record.amountY,

			printAmountString: this.state.data.record.printAmountString,
			amountStringX: this.state.data.record.amountStringX,
			amountStringY: this.state.data.record.amountStringY,

			printDate: this.state.data.record.printDate,
			dateX: this.state.data.record.dateX,
			dateY: this.state.data.record.dateY,

			printDateString: this.state.data.record.printDateString,
			dateStringX: this.state.data.record.dateStringX,
			dateStringY: this.state.data.record.dateStringY,

			printPayee: this.state.data.record.printPayee,
			payeeX: this.state.data.record.payeeX,
			payeeY: this.state.data.record.payeeY,

			printPayeeNationalId: this.state.data.record.printPayeeNationalId,
			payeeNationalIdX: this.state.data.record.payeeNationalIdX,
			payeeNationalIdY: this.state.data.record.payeeNationalIdY,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	setTafsil(e) {
		this.state.tafsilAccountId = e.value;
	}
	setDimansions(f, e) {
		if (this.isBlank(e)) e = '0';
		this.state.data.record[f] = e;
		this.setState({ data: this.state.data });
	}
	renderForm() {
		return <div className="modal fade in show" tabindex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }}></div>
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button type="button" className="close" onClick={e => this.closeMe()} ><span aria-hidden="true">×</span></button>
						<h4 className="modal-title" id="chequeReturnModalLabel">
							<span>الگوی چاپ چک</span>
						</h4>
					</div>
					<div className="modal-body">
						<div className="container-fluid">
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<label className="title1">عنوان الگو:</label>
										<input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
									</div>
								</div>
								<div className="col-sm-12">
									<div className="form-group">
										<input defaultChecked={this.state.data.record.printAmount} onChange={e => this.setDimansions('printAmount', e.target.checked)} type="checkbox" /> مبلغ
										<input defaultChecked={this.state.data.record.printAmountString} onChange={e => this.setDimansions('printAmountString', e.target.checked)} type="checkbox" /> مبلغ به حروف
										<input defaultChecked={this.state.data.record.printDate} onChange={e => this.setDimansions('printDate', e.target.checked)} type="checkbox" /> تاریخ
										<input defaultChecked={this.state.data.record.printDateString} onChange={e => this.setDimansions('printDateString', e.target.checked)} type="checkbox" /> تاریخ به حروف
										<input defaultChecked={this.state.data.record.printPayee} onChange={e => this.setDimansions('printPayee', e.target.checked)} type="checkbox" /> در وجه
										<input defaultChecked={this.state.data.record.printPayeeNationalId} onChange={e => this.setDimansions('printPayeeNationalId', e.target.checked)} type="checkbox" /> شناسه ملی گیرنده
									</div>
								</div>
								
								<div className="col-lg-6">
									<div className="row">											
										<div className="col-sm-12">
											<div className="form-group">
												<p>کلیه ابعاد خواسته شده در زیر را به صورت <b>میلی متر</b> وارد نمایید</p>
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">عرض برگه چک: </label>
												<input defaultValue={this.state.data.record.width} onChange={e => this.setDimansions('width', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">ارتفاع برگه چک: </label>
												<input defaultValue={this.state.data.record.height} onChange={e => this.setDimansions('height', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ مبلغ از لبه راست: </label>
												<input defaultValue={this.state.data.record.amountX} onChange={e => this.setDimansions('amountX', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ مبلغ از لبه بالا: </label>
												<input defaultValue={this.state.data.record.amountY} onChange={e => this.setDimansions('amountY', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ مبلغ به حروف از لبه راست: </label>
												<input defaultValue={this.state.data.record.amountStringX} onChange={e => this.setDimansions('amountStringX', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ مبلغ به حروف از لبه بالا: </label>
												<input defaultValue={this.state.data.record.amountStringY} onChange={e => this.setDimansions('amountStringY', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ تاریخ از لبه راست: </label>
												<input defaultValue={this.state.data.record.dateX} onChange={e => this.setDimansions('dateX', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ تاریخ از لبه بالا: </label>
												<input defaultValue={this.state.data.record.dateY} onChange={e => this.setDimansions('dateY', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ تاریخ به حروف از لبه راست: </label>
												<input defaultValue={this.state.data.record.dateStringX} onChange={e => this.setDimansions('dateStringX', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ تاریخ به حروف از لبه بالا: </label>
												<input defaultValue={this.state.data.record.dateStringY} onChange={e => this.setDimansions('dateStringY', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ شرح گیرنده از لبه راست: </label>
												<input defaultValue={this.state.data.record.payeeX} onChange={e => this.setDimansions('payeeX', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ شرح گیرنده از لبه بالا: </label>
												<input defaultValue={this.state.data.record.payeeY} onChange={e => this.setDimansions('payeeY', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ شناسه ملی گیرنده از لبه راست: </label>
												<input defaultValue={this.state.data.record.payeeNationalIdX} onChange={e => this.setDimansions('payeeNationalIdX', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label className="title1">فاصله محل چاپ شناسه ملی گیرنده از لبه بالا: </label>
												<input defaultValue={this.state.data.record.payeeNationalIdY} onChange={e => this.setDimansions('payeeNationalIdY', e.target.value)} autoComplete="off" type="text" className="form-input" />
											</div>
										</div>
									</div>
								</div>
								<div className="col-lg-6">
									<div style={{ overflowX: "scroll", width: "100%" }}>
										<div style={{ backgroundImage: "/assets/images/cheque-sample.jpg", position: "absolute", width: this.state.data.record.width + "mm", height: this.state.data.record.height + "mm" }}>
											{this.state.data.record.printAmount && <span style={{ position: "absolute", top: this.state.data.record.amountY + "mm", right: this.state.data.record.amountX + "mm", backgroundColor: "white" }}>محل نمایش مبلغ</span>}
											{this.state.data.record.printAmountString && <span style={{ position: "absolute", top: this.state.data.record.amountStringY + "mm", right: this.state.data.record.amountStringX + "mm", backgroundColor: "white" }}>محل نمایش مبلغ به حروف</span>}
											{this.state.data.record.printDate && <span style={{ position: "absolute", top: this.state.data.record.dateY + "mm", right: this.state.data.record.dateX + "mm", backgroundColor: "white" }}>محل نمایش تاریخ</span>}
											{this.state.data.record.printDateString && <span style={{ position: "absolute", top: this.state.data.record.dateStringY + "mm", right: this.state.data.record.dateStringX + "mm", backgroundColor: "white" }}>محل نمایش تاریخ به حروف</span>}
											{this.state.data.record.printPayee && <span style={{ position: "absolute", top: this.state.data.record.payeeY + "mm", right: this.state.data.record.payeeX + "mm", backgroundColor: "white" }}>محل نمایش شرح گیرنده</span>}
											{this.state.data.record.printPayeeNationalId && <span style={{ position: "absolute", top: this.state.data.record.payeeNationalIdY + "mm", right: this.state.data.record.payeeNationalIdX + "mm", backgroundColor: "white" }}>محل نمایش شناسه ملی گیرنده</span>}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
						<button onClick={e => this.save()} className="btn btn-success">ذخیره </button>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.renderForm()
			];

		return contents;
	}
}